import styled from 'styled-components';

const Wrapper = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  margin: 0;
  font-size: 13px;
  cursor: pointer;

  input[type="checkbox"] {
    display: none;
  }

  .checkbox-box {
    display: inline-block;
    width: 16px;
    height: 16px;
    margin: 0;
    position: relative;
    flex-shrink: 0;

    &:before {
      transition: all 0.3s ease-in-out;
      content: "";
      position: absolute;
      left: 0;
      top: 0;
      z-index: 1;
      width: 16px;
      height: 16px;
      background: transparent;
      border: 1px solid ${(props) => props.theme.colors.inactive};
      border-radius: 4px;
      box-sizing: border-box;
    }

    &:after {
      transition: all 0.3s ease-in-out;
      content: "";
      position: absolute;
      left: 0;
      top: 0;
      width: 16px;
      height: 16px;
      background: transparent;
      z-index: 0;
      border: none;
      border-radius: 4px;
      box-sizing: border-box;
    }
  }

  input[type="checkbox"]:checked + .checkbox-box {
    &:after {
      width: 16px;
      height: 16px;
      background: ${(props) => props.theme.colors.main_cta};
      transition: all 0.2s ease-in;
    }

    &:before {
      left: 5px;
      top: 2px;
      width: 6px;
      height: 11px;
      border: solid ${(props) => props.theme.colors.inactive};
      border-width: 0 2px 2px 0;
      transform: rotate(45deg);
      background: transparent;
    }
  }

  &.disabled {
    cursor: not-allowed;
    opacity: 50%;
  }
`;

export default { Wrapper };
